import styled from "styled-components";
import AbsPopup from "commons/popup/display/AbsPopup";
import { PopupType } from "../PopupType";
import { Navigation, Pagination, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useAbsPopupButton } from "commons/popup/store/absPopupHook";
import { ButtonState } from "commons/popup/store/absPopupVo";
import Button from "components/ui/Button";
import { useDispatch } from "react-redux";
import { rdxSetGuideStep } from "store/modules/auth/authR";
import { useGuideStepCheck, useGuideViewComplete } from "./UpdatePopupHook";

const Header = styled.div`
  position: absolute;
  top: -45px;
  right: -10px;
  button {
    font-size: 1.1rem;
    &::after {
      margin-left: 8px;
      width: 12px;
      height: 12px;
    }
  }
`;
const Footer = styled.div`
  position: absolute;
  bottom: -55px;
  left: 50%;
  transform: translateX(-50%);
  button {
    font-weight: 600;
    text-decoration: underline;
  }
`;
const Container = styled.div`
  width: 100%;
  height: 508px;
  position: relative;
`;

const StyledSwiper = styled(Swiper)`
  position: relative;
  width: 592px;
  height: 100%;
  /* background-color: #ddd; */
  border-radius: 8px;

  .swiper-button-prev,
  .swiper-button-next {
    background-color: #00000033;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-top: -100px;
    &:after {
      color: #fff;
      width: 100%;
      font-size: 1rem;
      text-align: center;
    }
  }
  .swiper-slide {
    img {
      width: 100%;
      height: 343px; /* 이미지 영역 높이 */
    }
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  height: 10px;
  top: 360px !important;
  position: absolute;
  left: 0;
  z-index: 100;

  .swiper-pagination-bullet-active {
    width: 25px;
    border-radius: 5px;
    background-color: var(--primary);
  }
`;

const TextContainer = styled.div`
  padding: 60px 0 20px;
  text-align: center;

  p {
    &.title {
      font-size: 1.45rem;
      color: #161c1c;
      font-weight: 600;
      margin-bottom: 14px;
    }

    &.content,
    &.sub {
      font-size: 1.03rem;
      color: #7c8484;
    }

    &.mini {
      font-size: 0.92rem;
      color: #999999;
    }
  }
`;
function PopupHeader() {
  const { close } = useAbsPopupButton(PopupType.UIUX_UPDATE_POPUP);
  const { step } = useGuideStepCheck();
  const { complete } = useGuideViewComplete();

  return step && step === 5 ? (
    <Header>
      <Button
        text="닫기"
        iconName="Closed"
        iconPosition="after"
        btnSize={"sm"}
        color="white"
        btnType={"ghost"}
        onClick={() => {
          complete();
          close(ButtonState.NO);
        }}
      />
    </Header>
  ) : (
    <></>
  );
}
export function PopupFooter() {
  const { step } = useGuideStepCheck();
  const { complete } = useGuideViewComplete();
  return step && step === 5 ? (
    <Footer>
      <Button
        color="white"
        btnType="ghost"
        btnSize="sm"
        text="업데이트 내용 자세히 보기"
        onClick={() => {
          complete();
          window.open("https://brainy-string-aaf.notion.site/240624_-f105737b0aa44fb4bb242a3a7b640c75?pvs=4");
        }}
      />
    </Footer>
  ) : (
    <></>
  );
}

function PopupContainerSwiper() {
  const dispatch = useDispatch();
  const list = [
    {
      title: "📬 6월 뷰어스 업데이트 소식",
      content: "새로운 모습으로 리뉴얼되어 돌아온 뷰어스!",
      sub: "어떤 기능들이 추가되고 개선된 부분은 무엇인지 알려드릴게요",
    },
    {
      title: "📍 서비스 기준 메뉴 관리",
      content: "서비스 유형에 따라 탭을 재구성했어요.",
      sub: "이제는 서비스 기준으로 편리하게 메뉴 관리가 가능해요!",
    },
    {
      title: "💵 바로 보는 예상 정산액",
      content: "이제는 콘텍스트-홈에서 당월 예상 정산액 확인이 가능해요!",
      mini: "*단, 예상 정산액이기에 실제 수익과는 차이가 있을 수 있습니다",
    },
    {
      title: "💡 콘텍스트 유통 플랫폼 데이터",
      content: "채널 기준 전체 유통사의 조회수 비율 확인과 각 유통 플랫폼의",
      sub: " 조회수와 같은 개별 데이터 확인이 가능해졌어요",
    },
    {
      title: "👀 음원 프리미엄 조회수",
      content: "음원 수익인 프리미엄 조회수를 제공해 투명한 정산 확인이 가능해졌습니다",
      mini: "*프리미엄 조회수 : 월 일정 금액을 지불하여 유료 구독 서비스를 이용하는 사용자들 조회수",
    },
    {
      title: "💎 수익 정산금 지급 완료 여부 확인 가능",
      content: "확인하기 어려웠던 이번달 정산금 지급 완료 여부를 알 수 있어요!",
      sub: "이제 채널톡을 통해 문의하지 않고 직접 확인이 가능해요",
    },
  ];
  return (
    <Container>
      <StyledSwiper
        modules={[Navigation, Pagination, A11y]}
        spaceBetween={50}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true, el: ".custom-pagination" }}
        // onSwiper={swiper => console.log(swiper)}
        onSlideChange={(v: any) => dispatch(rdxSetGuideStep(v.activeIndex))}
      >
        <PaginationContainer className="custom-pagination" />

        {list.map((item, index) => (
          <SwiperSlide key={index}>
            <img src={`/images/guide-swiper/${index + 1}.jpg`} alt={`업데이트 가이드 ${index + 1}`} />
            <TextContainer>
              <p className="title">{item.title}</p>
              <p className="content">{item.content}</p>
              {item.sub ? <p className="sub">{item.sub}</p> : null}
              {item.mini ? <p className="mini">{item.mini}</p> : null}
            </TextContainer>
          </SwiperSlide>
        ))}
      </StyledSwiper>
    </Container>
  );
}

export default function UiuxUpdatePopup(): JSX.Element {
  return (
    <AbsPopup type={PopupType.UIUX_UPDATE_POPUP} borderShape={8} header={<PopupHeader />}>
      <PopupContainerSwiper />
    </AbsPopup>
  );
}
